import React, { useState, useEffect } from 'react';
import { ValidatorForm } from 'react-form-validator-core';
import { connect } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { Input, Button } from '../../Atoms';
import { PasswordIcon, ErrorIcon } from '../../Assets';
import { Logo } from '../../Assets';
import { login, resetUser } from '../../redux/actions/AuthenticationAction';

import './login.scss';
import { Link } from 'react-router-dom';

const Login = ({
  signIn,
  login: { loading, error },
  userInfo: { success: userSuccess, info },
  resetUser,
}) => {
  const history = useHistory();
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [showPassword, setShowPassword] = useState(false);
  useEffect(() => {
    if (userSuccess) {
      resetUser();
      if (info.is_onboarded) {
        history.push('/');
      } else {
        history.push('/welcome');
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userSuccess]);

  const handleSubmit = () => {
    signIn(formData);
  };

  const handleChange = ({ target: { name, value } }) => {
    setFormData({ ...formData, [name]: value.trim() });
  };

  const handleCancel = () => {
    setFormData({ email: '', password: '' });
  };

  const handleIconClick = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="login-wrapper">
      <div className="login-form">
        <Logo />
        <div className="heading">Sign In</div>
        {error && (
          <div className="error-wrapper">
            <div>
              <ErrorIcon />
            </div>
            <span>{error}</span>
          </div>
        )}
        <ValidatorForm onSubmit={handleSubmit} className="form">
          <Input
            onChange={handleChange}
            value={formData.email}
            title="Email Address"
            placeholder="Email Address"
            name="email"
            validators={['required', 'isEmail']}
            errorMessages={['this field is required', 'email is not valid']}
            formValid={!error}
            style={{ marginBottom: 16 }}
          />
          <Input
            onChange={handleChange}
            value={formData.password}
            title="Password"
            type={showPassword ? 'text' : 'password'}
            placeholder="Password"
            name="password"
            validators={['required']}
            errorMessages={['this field is required']}
            formValid={!error}
            icon={PasswordIcon}
            handleClick={handleIconClick}
          />
          <div className="forgot-password-link">
            <Link to="/forgot-password">Forgot Password</Link>
          </div>
          <div className="onboarding-link">
            <Link to="/onboarding/company-code">New to Peak Mind? Get Started</Link>
          </div>
          <div className="action-btn">
            <Button type="button" size="sm" color="grey" onClick={handleCancel}>
              Cancel
            </Button>
            <Button type="submit" size="sm" color="blue" loading={loading}>
              Sign In
            </Button>
          </div>
        </ValidatorForm>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  login: state.auth.login,
  userInfo: state.auth.userInfo,
});

const mapDispatchToProps = (dispatch) => ({
  signIn: (details) => {
    dispatch(login(details));
  },
  resetUser: () => {
    dispatch(resetUser());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);
